import { distanceFromRight, distanceFromLeft, distanceFromBottom, distanceFromTop } from "./distances.es.js";
function adjustPlacement(placement, buffer = 16, preventOverflow = true) {
  return (targetRect, popoverRect) => {
    if (!targetRect || !popoverRect || !preventOverflow) {
      return placement;
    }
    switch (placement) {
      case "top":
        return distanceFromTop(targetRect, popoverRect) < buffer && distanceFromBottom(targetRect, popoverRect) >= buffer ? "bottom" : "top";
      case "bottom":
        return distanceFromBottom(targetRect, popoverRect) < buffer && distanceFromTop(targetRect, popoverRect) >= buffer ? "top" : "bottom";
      case "left":
        return distanceFromLeft(targetRect, popoverRect) < buffer && distanceFromRight(targetRect, popoverRect) >= buffer ? "right" : "left";
      case "right":
        return distanceFromRight(targetRect, popoverRect) < buffer && distanceFromLeft(targetRect, popoverRect) >= buffer ? "left" : "right";
    }
    return placement;
  };
}
export {
  adjustPlacement
};
